module.exports = __webpack_public_path__ + "static/1hr-12838f2a8615b4a745dc7e7fd9d3145f.svg";